import React from 'react';
import PropTypes from 'prop-types';

const CasesPartyResults = ({ data }) => (
  <div id="ir-search-search-premium-results">
    <h2>
      Results – {data.num_cases} {data.num_cases > 1 ? 'cases' : 'case'}
    </h2>
    <table className="ir-search-table-results sticky-enabled">
      <thead>
        <tr>
          <th>Case Title</th>
          <th>Party Name/Role</th>
          <th>Court</th>
          <th>Case No</th>
          <th>Chp</th>
          <th>Date&nbsp;Filed<br />Date&nbsp;Closed</th>
          <th>Disposition</th>
        </tr>
      </thead>
      <tbody>
        {data.results.map((row, idx) => (
          <tr key={idx}>
            <td>{row.case_title}</td>
            <td>{row.ncl_parties.map(({ name, role }, i) => (<div key={i}>{name} ({role})</div>))}</td>
            <td className="ir-search-court" title={row.court_name}>{row.case_court}</td>
            <td className="ir-search-no-wrap" title={row.case_title}>
              <b>
                <a
                  href={`/rpc/legacy/case-menu-redirect/${row.case_court}/${row.case_no}`}
                  target="_blank">{row.case_no}
                </a>
              </b>
            </td>
            <td>{row.chapter}</td>
            <td>{row.date_filed || row.date_closed}</td>
            <td>{row.disposition}</td>
          </tr>
          ))
        }
      </tbody>
    </table>
  </div>
);

CasesPartyResults.propTypes = {
  data: PropTypes.any.isRequired,
};

export default CasesPartyResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/CasesPartyResults.jsx